const getOptoutPreference = async function ( token, environment ) {
    const response = await fetch( `https://${ environment && environment !== 'prod' ? `${ environment }.` : '' }api.biw.cloud/v1/celebrations/preferences`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${ token }`
            }
        } );
        
        if ( response.ok ) {
            const body = await response.json();
            return body.data.preferences.optOut;
        } else {
            return null;
        }
};

const setOptoutPreference = async function ( token, environment, optOutPreference ) {
    const body = JSON.stringify( { optOut: optOutPreference } );
    const response = await fetch( `https://${ environment && environment !== 'prod' ? `${ environment }.` : '' }api.biw.cloud/v1/celebrations/preferences`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        },
        body: body
    } );
    if ( response.success ) {
        return response.celebrationPreference;
    } else {
        return true;
    }

};

export default {
    getOptoutPreference,
    setOptoutPreference
};